import React from "react";
export const VictoryAccessibleGroup = _ref => {
  let {
    desc,
    children,
    tabIndex,
    className = "VictoryAccessibleGroup",
    ...props
  } = _ref;
  const descId = desc && (props["aria-describedby"] || desc.split(" ").join("-"));
  return desc ? /*#__PURE__*/React.createElement("g", {
    "aria-label": props["aria-label"],
    "aria-describedby": descId,
    className: className,
    tabIndex: tabIndex
  }, /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), children) : /*#__PURE__*/React.createElement("g", {
    "aria-label": props["aria-label"],
    "aria-describedby": props["aria-describedby"],
    className: className,
    tabIndex: tabIndex
  }, children);
};